export const HOT_NEWS_HEADER_CONSTS = {
    addMsg: 'Добавить',
    haveNews: 'Горячая новость уже добавлена',
    newsNotFoundMsg: 'Новость не найдена',
    saveForAllRegionsMsg: 'Сохранить для всех регионов',
    saveMsg: 'Сохранить',
    urlLabelMsg: 'Ссылка на новость',
    wrongLink: 'Неправильная ссылка на новость'
}
